import { render, staticRenderFns } from "./LectureEntity.vue?vue&type=template&id=45b7b292&scoped=true"
import script from "./LectureEntity.vue?vue&type=script&lang=js"
export * from "./LectureEntity.vue?vue&type=script&lang=js"
import style0 from "./LectureEntity.vue?vue&type=style&index=0&id=45b7b292&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7b292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b7b292')) {
      api.createRecord('45b7b292', component.options)
    } else {
      api.reload('45b7b292', component.options)
    }
    module.hot.accept("./LectureEntity.vue?vue&type=template&id=45b7b292&scoped=true", function () {
      api.rerender('45b7b292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LectureEntity.vue"
export default component.exports